// ------------------------------------
// Imports
// ------------------------------------
import { getSubscriptionPortalApi } from 'api/subscriptions';
import { notify } from 'redux/actions/notice';
// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_SUBSCRIPTIONS_START = 'FETCH_SUBSCRIPTIONS_START';
export const FETCH_SUBSCRIPTIONS_END = 'FETCH_SUBSCRIPTIONS_END';
export const ERROR_SUBSCRIPTIONS = 'ERROR_SUBSCRIPTIONS';
// ------------------------------------
// Actions
// ------------------------------------
export function fetchSubscriptionsStart() {
  return ({ type: FETCH_SUBSCRIPTIONS_START });
}

export function fetchSubscriptionsEnd() {
  return ({ type: FETCH_SUBSCRIPTIONS_END });
}

export function raiseSubscriptionsError() {
  return ({ type: ERROR_SUBSCRIPTIONS });
}

export function getSubscriptionPortal(done) {
  return (dispatch) => {
    dispatch(fetchSubscriptionsStart());
    getSubscriptionPortalApi()
      .then((res = {}) => {
        const resBody = res.body;
        done(null, resBody);
        dispatch(fetchSubscriptionsEnd());
      })
      .catch((error) => {
        dispatch(notify({ error }));
        dispatch(raiseSubscriptionsError());
        done(error);
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/subscriptions.js